import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  Icon,
  Button,
  Dropdown,
  TextInput,
  Notification,
  Breadcrumb,
} from "pepsico-ds";
import { useEffect, useState } from "react";
import "./idx-attribute-bulk-load.css";
import { ToastContainer, toast } from "react-toastify";
import { useLoading } from "../../loader";

import idxService from "./idx.service";
import axios from "axios";

const IdxTestIdRequestPreProd = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { showLoader, hideLoader } = useLoading();
  const { REACT_APP_API_ENDPOINT } = process.env;

  const [isMobile] = useState(window.innerWidth <= 768);

  const [numberOfRecords, setNumberOfRecords] = useState("");
  const [series, setSeries] = useState([]);
  const [ownerGPID, setOwnerGPID] = useState("");
  const [ownerDetails, setOwnerDetails] = useState(null);
  const [ownerDisplayValue, setOwnerDisplayValue] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const seriesOptions = [
    {
      id: "91",
      displayText: "91*",
    },
    {
      id: "23",
      displayText: "23*",
    },
  ];

  const fetchGPIDDetails = async (gpid) => {
    if (!gpid?.trim()) {
      setOwnerDetails(null);
      return;
    }

    try {
      showLoader();

      const response = await axios.post(
        `${REACT_APP_API_ENDPOINT}user/searchuser`,
        {
          gpid,
          fetchOnlyActiveUsers: true,
        },
      );
      console.log("Search User Response", response.data);

      const user = Object.values(response?.data?.userData || {})[0];

      if (response?.data?.status !== "Failed" && user) {
        setOwnerDetails(user);

        setOwnerDisplayValue(`${user.givenName} ${user.sn} (${user.uid})`);
      } else {
        setOwnerDetails(null);
        toast.error("Invalid GPID");
      }
    } catch (error) {
      console.error(error);
      setOwnerDetails(null);
      toast.error("Unable to fetch GPID details");
    } finally {
      hideLoader();
    }
  };

  // useEffect(() => {
  //   const data = JSON.parse(localStorage.getItem("okta-token-storage"));

  //   const loggedInGPID = data?.accessToken?.claims?.gpid || "";

  //   setOwnerGPID(loggedInGPID);

  //   if (loggedInGPID) {
  //     fetchGPIDDetails(loggedInGPID);
  //   }
  // }, []);

  useEffect(() => {
    if (isSuccess) {
      const timer = setTimeout(() => {
        setIsSuccess(false);
        navigate("/home");
      }, 4000);

      return () => clearTimeout(timer);
    }
  }, [isSuccess, navigate]);

  const handleSubmit = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);
    showLoader();

    try {
      const payload = {
        numberOfRecords: Number(numberOfRecords),
        series: `${series?.[0]?.id}*`,
        ownerGpid: ownerGPID,
      };

      const response = await idxService.submitTestIdRequest(payload);

      if (
        response?.status === "Failed" ||
        response?.responseStatus === "Failed"
      ) {
        toast.error(
          response?.errorMessage || t("entraGuest.request_fail_message"),
        );
        setIsSubmitting(false); // allow retry on failure
        return;
      }

      setIsSuccess(true);
      window.scrollTo(0, 0);

      // Keep disabled after successful submit
    } catch (error) {
      toast.error(t("entraGuest.request_fail_message"));
      setIsSubmitting(false); // allow retry on failure
    } finally {
      hideLoader();
    }
  };

  const disableSubmit = () => {
    return (
      isSubmitting ||
      !(
        numberOfRecords &&
        Number(numberOfRecords) > 0 &&
        Number(numberOfRecords) <= 50 &&
        series?.length > 0 &&
        ownerDetails
      )
    );
  };

  return (
    <>
      <div className="idx-main-container">
        <div
          className={isMobile ? "row" : "container"}
          style={{
            background: "none",
            boxShadow: "none",
            justifyContent: isMobile ? "center" : "",
          }}
        >
          <div
            style={{
              width: "100%",
              flexDirection: isMobile ? "column" : "row",
              gap: isMobile ? "0px" : "15px",
              flexWrap: "wrap",
              flex: 1,
            }}
          >
            {/* {isSuccess && (
              <Notification
                className="mb-3"
                showActionButtons={false}
                showIcon
                text={t("idx.success_notification")}
                type="success"
              />
            )} */}
            {isSuccess && (
              <Notification
                className="mb-3"
                showActionButtons={false}
                showIcon
                showText={false}
                showTitle
                title={t("idx.success_notification")}
                type="success"
              />
            )}

            <div
              className={isMobile ? "row mt-2" : ""}
              style={{
                justifyContent: isMobile ? "center" : "",
              }}
            >
              <div
                className={`${
                  isMobile ? "pl-4 pr-4 ml-4 mr-4" : ""
                } ad-main-heading-container`}
              >
                <Breadcrumb
                  homeIcon={{
                      icon: "home",
                      onClick:()=>{
                      navigate("/home")
                      }
                  }}
                  breadcrumbs={[
                    {
                      label: t("menu.home"),
                    },
                    {
                      label: t("idx.idx_test_id_request_preprod"),
                    },
                  ]}
                  className="idx-breadcrumb"
                  useAnchor
                />

                <div className="ad-page-header">
                  <div className="ad-main-heading">
                    {t("idx.idx_test_id_request_preprod")}
                  </div>
                </div>
              </div>

              <div
                className="card-layout reg-card mb-3 mb-md-0 active-directory-card-container idx-container"
                style={{
                  flex: isMobile ? "unset" : "0 0 calc(66.666% - 7.5px)",
                  width: isMobile ? "100%" : "auto",
                  flexDirection: isMobile ? "column" : "row",
                  gap: "1rem",
                }}
              >
                <div className="w-100">
                  <div className="card card-content align-items-center">
                    <div className="bulk-upload-section w-50">
                    <TextInput
  label={t("idx.number_of_records")}
  placeholderText={t("idx.enter_number_of_records")}
  value={numberOfRecords}
  required
  maxLength={2}
  helperText={t("idx.maximum_test_account_limit")}
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");

    if (!value) {
      setNumberOfRecords("");
      return;
    }

    const num = Number(value);

    setNumberOfRecords(num > 50 ? "50" : value);
  }}
/>

                      <Dropdown
                        className="mb-3"
                        childList={seriesOptions}
                        label={t("idx.series")}
                        placeholder={t(
                          "RequestGPIDForNonEmployee.select_btn_label",
                        )}
                        menuPosition="bottom-right"
                        isClearable
                        selection="single"
                        selectedValue={series}
                        setSelectedValue={setSeries}
                        showLabelIcon={false}
                        isRequired
                      />

                      <div style={{ position: "relative" }}>
                        <TextInput
                          label={t("idx.owner_gpid")}
                          placeholderText={t("idx.owner_gpid_placeholder")}
                          value={ownerDisplayValue || ownerGPID}
                          required
                          maxLength={8}
                          helperText={t("auditRequest.gpid_limit_message")}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");

                            setOwnerGPID(value);

                            setOwnerDetails(null);
                            setOwnerDisplayValue("");
                          }}
                          onBlur={() => {
                            if (ownerGPID?.length === 8) {
                              fetchGPIDDetails(ownerGPID);
                            }
                          }}
                        />

                        {!ownerGPID?.trim() && (
                          <div
                            style={{
                              position: "absolute",
                              right: "6px",
                              top: "30px",
                              pointerEvents: "none",
                            }}
                          >
                            <Icon icon="search" size="20px" />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="idx-footer mt-3">
        <div className="row footer-row-with-footer-buttons">
          <div className="footer-buttons">
            <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0 px-md-0 justify-content-center">
              <Button
                className="search-user-cancel-button mr-md-2 my-0"
                size="medium"
                text={t("RequestGPIDForNonEmployee.cancel_btn_label")}
                variant="tertiary"
                onClick={() => navigate(-1)}
              />
            </div>

            <div className="col-md-auto align-self-center d-flex mb-3 mb-md-0">
              <Button
                className="search-user-select-button request-button my-0 px-3 justify-content-center"
                size="medium"
                text={t("nonArExtension.submit")}
                variant="primary"
                onClick={handleSubmit}
                disabled={disableSubmit()}
              />
            </div>
          </div>
        </div>

        <ToastContainer position="bottom-center" />
      </div>
    </>
  );
};

export default IdxTestIdRequestPreProd;
